import { getKeys } from './getKeys'

export const residentHealthRecordsTranslations = {
  COMMUNICATION_RECORDS: 'Communication Records',
  ADD_COMMUNICATION_RECORD: 'Add Record of Communication',
  COMMUNICATION_RECORD: 'Communication Record',
  ADD: 'Add',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  COMMUNICATION_TITLE: 'Communication title',
  COMMUNICATION_DESCRIPTION: 'Description of the communication',
  DOCUMENT_UPLOAD: 'Document upload',
  IS_REQUIRED: 'is required',
  ENTER: 'Enter',
  UPLOAD_DOCUMENT: 'Click to upload',
  WHO_SENT: 'Who sent the information',
  RECIPIENT: 'Recipient',
  SELECT: 'Select',
  DATE_SENT: 'Date sent',
  STATUS_OF_COMMUNICATION: 'Status of communication',
  STATUS_PREPARATION: 'Preparation',
  STATUS_COMPLETED: 'Completed',
  STATUS_ENTERED_IN_ERROR: 'Entered in error',
  STATUS_IN_PROGRESS: 'In progress',
  STATUS_NOT_DONE: 'Not done',
  STATUS_ON_HOLD: 'On hold',
  STATUS_STOPPED: 'Stopped',
  STATUS_UNKNOWN: 'Unknown',
  STATUS_PREPARATION_DESCRIPTION:
    'The core event has not started yet, but some staging activities have begun (e.g. surgical suite preparation). Preparation stages may be tracked for billing purposes.',
  STATUS_COMPLETED_DESCRIPTION: 'The event has now concluded.',
  STATUS_ENTERED_IN_ERROR_DESCRIPTION:
    'This electronic record should never have existed, though it is possible that real-world decisions were based on it. (If real-world activity has occurred, the status should be "stopped" rather than "entered-in-error".).',
  STATUS_IN_PROGRESS_DESCRIPTION: 'The event is currently occurring.',
  STATUS_NOT_DONE_DESCRIPTION:
    "The event was terminated prior to any activity beyond preparation. I.e. The 'main' activity has not yet begun. The boundary between preparatory and the 'main' activity is context-specific.",
  STATUS_ON_HOLD_DESCRIPTION:
    'The event has been temporarily stopped but is expected to resume in the future.',
  STATUS_STOPPED_DESCRIPTION:
    "The event was terminated prior to the full completion of the intended activity but after at least some of the 'main' activity (beyond preparation) has occurred.",
  STATUS_UNKNOWN_DESCRIPTION:
    'The authoring/source system does not know which of the status values currently applies for this event.',
  NO_COMMUNICATION_RECORDS: 'No Communication Records',
  NO_COMMUNICATION_RECORDS_DESCRIPTION:
    'There are no communication records for this resident yet.',
  VIEW: 'View',
  EDIT: 'Edit',
  DELETE: 'Delete',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_COMMUNICATION_RECORD:
    'Are you sure you want to delete this communication record?',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_COMMUNICATION_RECORD_DESCRIPTION:
    "Are you sure you want to delete this communication record? If you go ahead, it can't be undone. Once it's gone, it's gone for good!"
}

export const residentHealthRecordsConstants = getKeys(
  residentHealthRecordsTranslations
)
